module.exports = __webpack_public_path__ + "static/img_0737-c287aa62e4730a80128b0d40e88d8fd5.webp";